export default {"src":"/_next/static/media/infinity_64.12fc80c5.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};